export default {"src":"/_next/static/media/startup-logo2.5c2a40c0.svg","height":32,"width":103,"blurWidth":0,"blurHeight":0};